<template>
  <div class="modal fade" :id="id" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ modalTitle }}</h5>
          <button v-if="!loading" type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div v-if="loading" class="text-center">
            <div class="spinner-border" role="status">
              <span class="sr-only">Cargando...</span>
            </div>
            <p class="mt-2">Enviando archivo...</p>
          </div>

          <form v-else-if="!accepted && !requestError" @submit.prevent="submitForm">
            <div class="alert alert-info" role="alert">
              <strong>Formato del CSV requerido:</strong>
              <ul class="mb-0 mt-2">
                <li>Una sola columna con la cabecera <code>CONTRACTID</code></li>
                <li>Un contrato por fila, sin duplicados</li>
                <li>Máximo 40 contratos por carga</li>
              </ul>
            </div>

            <div class="form-group">
              <label :for="`${id}File`">Adjuntar CSV de contratos:</label>
              <input
                ref="fileInput"
                type="file"
                class="form-control"
                :id="`${id}File`"
                accept=".csv"
                @change="handleFileUpload"
                required
              >
              <ul v-if="fileErrors.length" class="text-danger small pl-3 mt-2 mb-0">
                <li v-for="error in fileErrors" :key="error">{{ error }}</li>
              </ul>
            </div>
            <div class="d-flex justify-content-end">
              <button type="button" class="btn btn-secondary mr-2" data-dismiss="modal">
                Cancelar
              </button>
              <button type="submit" class="btn btn-primary" :disabled="!contractIds.length">
                ENVIAR
              </button>
            </div>
          </form>

          <div v-else-if="accepted" class="text-center">
            <div class="alert alert-success">
              <strong>Solicitud de actualización aceptada</strong>
              <p class="mb-0 mt-2">Los contratos se procesan en segundo plano. Este mensaje no confirma que ya estén actualizados.</p>
            </div>
            <button type="button" class="btn btn-primary" data-dismiss="modal">
              Cerrar
            </button>
          </div>

          <div v-else class="text-center">
            <div class="alert alert-danger">{{ requestError }}</div>
            <button type="button" class="btn btn-secondary" @click="resetForm">
              Intentar de nuevo
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import axios from 'axios';
import { parseContractIdsCsv, buildContractIdsCsv } from '@/helpers/contractIdsCsv';

export default {
  name: 'ModalRefreshPaymentPlans',
  props: {
    id: String,
    modalTitle: String,
  },
  data() {
    return {
      fileName: '',
      contractIds: [],
      fileErrors: [],
      loading: false,
      accepted: false,
      requestError: '',
    };
  },
  mounted() {
    // Resetting on click would remove the dismiss button before Bootstrap handles its click
    $(this.$el).on('hidden.bs.modal', this.resetForm);
  },
  beforeUnmount() {
    $(this.$el).off('hidden.bs.modal', this.resetForm);
    // A 401/403 makes the interceptor navigate away while this modal is open
    if (this.$el.classList.contains('show')) {
      document.querySelectorAll('.modal-backdrop').forEach((backdrop) => backdrop.remove());
      document.body.classList.remove('modal-open');
    }
  },
  methods: {
    async handleFileUpload(event) {
      const file = event.target.files[0];
      this.contractIds = [];
      this.fileErrors = [];
      if (!file) return;

      if (!file.name.toLowerCase().endsWith('.csv')) {
        this.fileErrors = ['Selecciona un archivo CSV. No se admiten archivos de Excel.'];
        return;
      }

      const { contractIds, errors } = parseContractIdsCsv(await file.text());
      this.fileName = file.name;
      this.contractIds = contractIds;
      this.fileErrors = errors;
    },
    submitForm() {
      const formData = new FormData();
      const csv = new File([buildContractIdsCsv(this.contractIds)], this.fileName, { type: 'text/csv' });
      formData.append('csv', csv);

      this.loading = true;
      axios.patch('/payment/payment-plan/refresh-async', formData)
        .then(() => {
          this.accepted = true;
        })
        .catch((error) => {
          this.requestError = error.response && error.response.status === 400
            ? 'El archivo CSV no es válido. Revisa el formato e inténtalo de nuevo.'
            : 'Ha ocurrido un error, inténtelo de nuevo. Si el problema persiste contacte con el administrador del sistema.';
        })
        .finally(() => {
          this.loading = false;
        });
    },
    resetForm() {
      this.fileName = '';
      this.contractIds = [];
      this.fileErrors = [];
      this.accepted = false;
      this.requestError = '';
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = '';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.spinner-border {
  color: #cc0b7a;
}

.btn-primary {
  background-color: #cc0b7a;
  border-color: #cc0b7a;

  &:hover {
    background-color: #a30962;
    border-color: #a30962;
  }

  &:disabled {
    background-color: #e085b3;
    border-color: #e085b3;
  }
}

.modal-content {
  padding: 15px;
}

code {
  background-color: #f8f9fa;
  padding: 2px 6px;
  border-radius: 3px;
  color: #cc0b7a;
}
</style>
